export enum Role {
    WarehouseManager = 'WarehouseManager',
    WarehouseOwner = 'WarehouseOwner',
    ProjectAdmin = 'ProjectAdmin',
    ProjectManager = 'ProjectManager',
    ProcurementManager = 'ProcurementManager',
    SystemAdmin = 'SystemAdmin',
    Employee = 'Employee',
    CEO = 'CEO',
    FinanceManager = 'FinanceManager',
}

export enum KeyRolePair {
    WarehouseManager = '3ad36a7c-5334-4772-bfd9-ece3647433ea',
    WarehouseOwner = 'cd6c402f-5bb4-4663-b743-e41583e0600e',
    ProjectAdmin = '3bd36e70-0190-443b-97fc-a78ab8c5d334',
    ProjectManager = 'cdb8ba34-a3c3-4fd1-b398-06e27c721048',
    ProcurementManager = 'a77cbc3e-2526-4c9c-8bc0-6e62be8d0173',
    SystemAdmin = 'e1864afd-575d-42e7-b8ed-a56d2bcecf9c',
    Employee = '1617e9d1-3bbb-4f4b-904d-457b020d6f4e',
    // CEO has no Azure AD app role yet: add its appRoleId GUID here and a case below to enable it.
    FinanceManager = '3d04470b-fe59-4b9d-beca-bad0d71b36b8',
}

export const findRoleNameBasedOnKey = (key: string) => {
    switch (key) {
        case KeyRolePair.WarehouseManager:
            return Role.WarehouseManager;
        case KeyRolePair.WarehouseOwner:
            return Role.WarehouseOwner;
        case KeyRolePair.ProjectAdmin:
            return Role.ProjectAdmin;
        case KeyRolePair.ProjectManager:
            return Role.ProjectManager;
        case KeyRolePair.ProcurementManager:
            return Role.ProcurementManager;
        case KeyRolePair.SystemAdmin:
            return Role.SystemAdmin;
        case KeyRolePair.Employee:
            return Role.Employee;
        case KeyRolePair.FinanceManager:
            return Role.FinanceManager;
        default:
            return Role.Employee;
    }
};
